// @flow

import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 16px;
  position: relative;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.colors.neutral[700]};
  margin-bottom: 8px;
`;

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  padding: 0 16px;
  border: 1px solid ${props => props.theme.colors.neutral[200]};
  border-radius: 8px;
  background: ${props => props.theme.colors.neutral.white};
  cursor: pointer;
  font: inherit;

  ${(props) => props.isOpen && css`
    border-color: ${props.theme.colors.new_primary[500]};
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}

  &:disabled {
    background-color: ${props => props.theme.colors.neutral[100]};
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const TriggerText = styled.span`
  font-size: 14px;
  color: ${(props) => props.hasValue ? props.theme.colors.neutral[700] : props.theme.colors.neutral[300]};
`;

export const Chevron = styled.span`
  display: flex;
  align-items: center;
  transition: transform 0.2s;
  ${(props) => props.isOpen && css`
    transform: rotate(180deg);
  `}
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% - 8px);
  left: 0;
  right: 0;
  z-index: 10;
  border: 1px solid ${props => props.theme.colors.new_primary[500]};
  border-top: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: ${props => props.theme.colors.neutral.white};
`;

export const SearchInput = styled.input`
  display: block;
  width: calc(100% - 32px);
  margin: 12px 16px;
  padding: 10px 12px;
  border: 1px solid ${props => props.theme.colors.neutral[200]};
  border-radius: 6px;
  font-size: 16px;
  outline: none;

  &::placeholder {
    color: ${props => props.theme.colors.neutral[300]};
  }

  &:focus {
    border-color: ${props => props.theme.colors.new_primary[500]};
  }
`;

export const OptionsList = styled.div`
  max-height: 200px;
  overflow-y: auto;
  padding-bottom: 8px;
`;

export const OptionItem = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: none;
  cursor: pointer;
  font: inherit;
  text-align: left;

  &:hover {
    background: ${props => props.theme.colors.neutral[100]};
  }

  ${(props) => props.isSelected && css`
    background: ${props.theme.colors.neutral[100]};
  `}
`;

export const RadioCircle = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${(props) => props.isSelected ? props.theme.colors.new_primary[500] : props.theme.colors.neutral[300]};
  margin-right: 12px;
  flex-shrink: 0;
  position: relative;

  ${(props) => props.isSelected && css`
    &::after {
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: ${props => props.theme.colors.new_primary[500]};
    }
  `}
`;

export const OptionText = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.neutral[700]};
`;

export const LoadingText = styled.p`
  padding: 12px 16px;
  font-size: 14px;
  color: ${props => props.theme.colors.neutral[300]};
`;

export const EmptyText = styled.p`
  padding: 12px 16px;
  font-size: 14px;
  color: ${props => props.theme.colors.neutral[300]};
`;

export const ErrorText = styled.p`
  padding: 12px 16px;
  font-size: 14px;
  color: ${props => props.theme.colors.feedback.error[500]};
`;

export const BankLogo = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: contain;
  flex-shrink: 0;
  margin-right: 8px;
`;

export const BankLogoPlaceholder = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${props => props.theme.colors.new_primary[50]};
  color: ${props => props.theme.colors.new_primary[500]};
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 8px;
`;
